module.exports = __webpack_public_path__ + "static/media/example-3.bd0376a4.png";